import { makeVar } from "@apollo/client";
import { PageType } from "../types/Page";
import { SubscriptionAccess } from "../service/subscriptionTrial";

export const pageVar = makeVar<PageType | null>(null);
export const subscriptionAccessVar = makeVar<SubscriptionAccess | null>(null);
export const isActiveTrialShow = makeVar<boolean>(false);
export const isTrialEndedShow = makeVar<boolean>(false);
export const isTrialBlockedShow = makeVar<boolean>(false);
